export default "__VITE_ASSET__aN7ds75R__"